// extracted by mini-css-extract-plugin
export default {"merch":"Merch_merch__BDEOd","merchItem":"Merch_merchItem__NCSwn"};